import { useQuery } from '@tanstack/react-query';
import { notificationCenterApi } from '../api/notificationCenterApi';

/**
 * GET /api/eraf/notification-center/stats — 채널별 통계 (NOTIFICATION_READ)
 * queryKey: ['notification-center', 'stats']
 */
export function useNotificationStats(params?: { from?: string; to?: string }) {
  return useQuery({
    queryKey: ['notification-center', 'stats', params],
    queryFn: () => notificationCenterApi.stats(params),
    staleTime: 30_000,
  });
}
